import React from "react";
import { LoadingRow, SkeletonBar, StyledTd } from "./styles";

interface LoadingSkeletonProps {
  columnCount?: number;
  rowCount?: number;
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  columnCount = 5,
  rowCount = 10,
}) => {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIdx) => (
        <LoadingRow key={`loading-row-${rowIdx}`}>
          {Array.from({ length: columnCount }).map((_, colIdx) => (
            <StyledTd key={`loading-cell-${rowIdx}-${colIdx}`}>
              <SkeletonBar style={{ width: `${60 + Math.random() * 40}%` }} />
            </StyledTd>
          ))}
        </LoadingRow>
      ))}
    </>
  );
};
